import * as Actions from './AdminWebinarsActions';
import { normalizeWebinars } from '../Webinars/WebinarsUtils';
import { getDifference, getUnion, sortArrayBasedOnArray } from '../../Utils/ArrayUtils';

const initialState = {
  fetching: false,
  webinarsFetching: false,
  creatorsFetching: false,
  webinars: {
    byKey: {},
    allKeys: [],
    deSelectedKeys: [],
    filteredKeys: [],
    filteredSelectedWebinarKeys: []
  },
  filter: {
    searchString: '',
    fromTime: null,
    toTime: null,
    creators: []
  },
  pagination: {
    total: 0,
    limit: 0,
    page: 0,
    pageSize: 20
  },
  creators: {
    nextPage: null,
    page: 0,
    creators: [],
    filteredCreators: []
  },
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_ADMIN_WEBINARS_REQUEST: {
      return {
        ...state,
        filter: {
          ...state.filter,
          fromTime: action.payload.fromTime,
          toTime: action.payload.toTime
        },
        fetching: action.payload.loadPage,
        webinarsFetching: !action.payload.loadPage,
        error: null
      };
    }
    case Actions.GET_ADMIN_WEBINARS_SUCCESS: {
      const webinarsList = action.payload.webinarsList || [];
      const { allKeys, byKey } = normalizeWebinars(webinarsList);
      const { searchString = state.filter.searchString, pagination, creators } = action.payload;
      const newFilteredKeys = getFilteredWebinarKeys(allKeys, byKey, searchString);

      const deSelect = getDifference(newFilteredKeys, state.webinars.filteredSelectedWebinarKeys);
      const select = getDifference(newFilteredKeys, deSelect);
      return {
        ...state,
        fetching: false,
        webinarsFetching: false,
        webinars: {
          ...state.webinars,
          byKey,
          allKeys,
          filteredKeys: newFilteredKeys,
          deSelectedKeys: deSelect,
          filteredSelectedWebinarKeys: select
        },
        filter: {
          ...state.filter,
          creators: creators
        },
        pagination
      };
    }
    case Actions.GET_ADMIN_WEBINARS_FAILURE:
      return { ...state, ...initialState, fetching: false, error: action.error };
    case Actions.TOGGLE_ADMIN_WEBINAR: {
      const { webinarKey, isSelected } = action.payload;
      const { deSelectedKeys: existingDeSelectedKeys, allKeys, filteredKeys } = state.webinars;
      const newDeSelectedKeys = isSelected
        ? existingDeSelectedKeys.filter(key => key !== webinarKey)
        : sortArrayBasedOnArray([...existingDeSelectedKeys, webinarKey], allKeys);
      const newFilterSelectedWebinarKeys = getDifference(filteredKeys, newDeSelectedKeys);
      return {
        ...state,
        webinars: {
          ...state.webinars,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedWebinarKeys: newFilterSelectedWebinarKeys
        }
      };
    }
    case Actions.TOGGLE_ALL_ADMIN_WEBINARS: {
      const { deSelectedKeys, filteredKeys } = state.webinars;
      const newDeSelectedKeys = action.payload.isSelected
        ? getDifference(deSelectedKeys, filteredKeys)
        : getUnion(deSelectedKeys, filteredKeys);
      const newFilterSelectedWebinarKeys = getDifference(filteredKeys, newDeSelectedKeys);
      return {
        ...state,
        webinars: {
          ...state.webinars,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedWebinarKeys: newFilterSelectedWebinarKeys
        }
      };
    }
    case Actions.GET_WEBINAR_CREATORS_REQUEST: {
      return {
        ...state,
        creatorsFetching: true,
        creators: action.payload.loadCreators
          ? { ...initialState.creators, filteredCreators: state.creators.filteredCreators }
          : state.creators
      };
    }
    case Actions.GET_WEBINAR_CREATORS_SUCCESS: {
      const creators = [...state.creators.creators, ...action.payload.creators];
      return {
        ...state,
        creatorsFetching: false,
        creators: {
          ...state.creators,
          page: action.payload.page,
          nextPage: action.payload.nextPage,
          filteredCreators: action.payload.filter ? [...state.creators.filteredCreators] : creators,
          creators: creators
        }
      };
    }
    case Actions.GET_WEBINAR_CREATORS_FAILURE:
      return { ...state, ...initialState, creatorsFetching: false, error: action.error };
    case Actions.RESET_WEBINAR_CREATORS_REQUEST:
      return {
        ...state,
        creators: {
          ...state.creators,
          creators: [...state.creators.filteredCreators]
        }
      };
    default:
      return state;
  }
};

let getFilteredWebinarKeys = function(allWebinarKeys, webinarsMap, searchString) {
  if (searchString === null) {
    return [...allWebinarKeys];
  }
  return allWebinarKeys.filter(webinarKey => {
    const webinar = webinarsMap[webinarKey] || {};
    const { name } = webinar;
    return searchString && name ? name.toUpperCase().includes(searchString.toUpperCase()) : true;
  });
};



// WEBPACK FOOTER //
// ./src/Reducks/AdminWebinars/AdminWebinarsReducer.js